<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      :before-close="beforeCloseHandle"
    >
      <div class="content-box">
        <div
          class="video-box"
          :style="{height: containerHeight + 'px'}"
        >
          <div
            v-if="dialogVisible"
            id="controlVideo"
            style="width: 100%; height: 100%;"
          ></div>
        </div>
        <div class="control-box">
          <div class="direction-box">
            <div class="line line-row row-one"></div>
            <div class="line line-row row-two"></div>
            <div class="line line-col col-one"></div>
            <div class="line line-col col-two"></div>
            <img
              src="@/assets/images/realtime/flip.png"
              title="镜像翻转"
              class="flip-btn"
              @click="changeControl('')"
            />
            <img
              src="@/assets/images/realtime/direction.png"
              title="上"
              class="direction01"
              @click="changeControl('0')"
            />
            <img
              src="@/assets/images/realtime/direction.png"
              title="右上"
              class="direction02"
              @click="changeControl('6')"
            />
            <img
              src="@/assets/images/realtime/direction.png"
              title="右"
              class="direction03"
              @click="changeControl('3')"
            />
            <img
              src="@/assets/images/realtime/direction.png"
              title="右下"
              class="direction04"
              @click="changeControl('7')"
            />
            <img
              src="@/assets/images/realtime/direction.png"
              title="下"
              class="direction05"
              @click="changeControl('1')"
            />
            <img
              src="@/assets/images/realtime/direction.png"
              title="左下"
              class="direction06"
              @click="changeControl('5')"
            />
            <img
              src="@/assets/images/realtime/direction.png"
              title="左"
              class="direction07"
              @click="changeControl('2')"
            />
            <img
              src="@/assets/images/realtime/direction.png"
              title="左上"
              class="direction08"
              @click="changeControl('4')"
            />
          </div>
          <div class="control-btn">
            <i
              class="el-icon-minus"
              title="缩小"
              @click="changeControl('9')"
            ></i>
            <span>变倍</span>
            <i
              class="el-icon-plus"
              title="变大"
              @click="changeControl('8')"
            ></i>
          </div>
          <div class="control-btn">
            <i
              class="el-icon-minus"
              title="近焦距"
              @click="changeControl('10')"
            ></i>
            <span>变焦</span>
            <i
              class="el-icon-plus"
              title="远焦距"
              @click="changeControl('11')"
            ></i>
          </div>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="submitHandle">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { startControl, stopControl } from '@/api/device'
import { mapState } from 'vuex'
import EZUIKit from 'ezuikit-js'
const defaultControlForm = {
  eq_id: '',
  deviceId: '',
  channelId: '',
  // 操作命令 0-上，1-下，2-左，3-右，4-左上，5-左下，6-右上，7-右下，8-放大，9-缩小，10-近焦距，11-远焦距
  direction: '',
  // （镜像翻转时必填）镜像方向：0-上下, 1-左右, 2-中心
  command: '',
  speed: 1,	// 是	int	云台速度：0-慢，1-适中，2-快，海康设备参数不可为0
  control_type: 2	// 是	int	1开始云台控制 2 停止云台控制 3 镜像翻转
}
export default {
  data() {
    return {
      player: null,
      info: {
        index: 0,
        accessToken: '',
        url: ''
      },
      dialogVisible: false,
      controlForm: { ...defaultControlForm }
    }
  },

  computed: {
    ...mapState({
      projectItem: state => state.user.projectItem
    }),
    title() {
      return '云控制台'
    },
    containerHeight() {
      return Math.round(this.$store.state.app.mainHeight * 2 / 3)
    }
  },
  methods: {
    beforeCloseHandle(done) {
      console.log('beforeCloseHandle', this.info)
      this.stopControl()
      if (this.player) {
        this.player.stop()
      }
      this.player = null
      console.log('close', this.info)
      this.$emit('close', this.info)
      done && done()
    },
    playHandle() {
      this.$nextTick(() => {
        const url = this.info.url
        if (this.player) {
          this.player.stop()
          this.player.play({
            url
          })
          return
        }
        this.player = new EZUIKit.EZUIKitPlayer({
          autoplay: true,
          id: 'controlVideo',
          accessToken: this.info.accessToken,
          url,
          handleError: this.handleError,
          template: 'simple' // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
        })
      })
    },
    submitHandle() {
      this.beforeCloseHandle()
      this.dialogVisible = false
    },
    init(data) {
      console.log(data)
      this.dialogVisible = true
      this.controlForm = { ...defaultControlForm, businessId: this.projectItem.projectId }
      this.info = data
      this.controlForm.eq_id = data.eq_id
      this.controlForm.deviceId = data.deviceId
      this.controlForm.channelId = data.channelId || '1'

      console.log('this.info', this.info)
      console.log('this.controlForm', this.controlForm)
      this.playHandle()
      this.stopControl()
    },
    changeControl(direction) {
      if (this.controlForm.control_type === 1) {
        this.stopControl()
        return
      }
      this.controlForm.direction = direction
      if (direction === '') {
        // 镜像翻转
        this.controlForm.control_type = 3
        // if(this.controlForm.command == 2) {
        //     this.controlForm.command = 0;
        // } else if(this.controlForm.command == 0) {
        //     this.controlForm.command = 1;
        // } else if(this.controlForm.command == 1) {
        //     this.controlForm.command = 2;
        // }
        this.controlForm.command = 1
      } else {
        this.controlForm.control_type = 1
        this.controlForm.command = ''
        // 开始云台控制
      }
      console.log('this.controlForm', this.controlForm)
      startControl(this.controlForm).then(res => {

      })
    },
    // 停止云台控制
    stopControl() {
      this.controlForm.control_type = 2
      return stopControl(this.controlForm)
    }
  }
}
</script>

<style lang="scss" scoped>
	.content-box {
		display: flex;
		.video-box {
			flex: 1;
			background: #000;
		}
		.control-box {
			width: 240px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}
		.direction-box {
			width: 200px;
			height: 200px;
			border-radius: 50%;
			border: 1px solid rgba(0, 204, 255, 1);
			box-sizing: border-box;
			position: relative;
			margin-bottom: 20px;
			img {
				cursor: pointer;
				position: absolute;
				width: 50px;
			}
		}
		.line {
			position: absolute;
		}
		.line-row {
			width: 190px;
			height: 1px;
			background-color: #666;
		}
		.line-col {
			width: 1px;
			height: 190px;
			background-color: #666;
		}
		.row-one {
			top: 68px;
			left: 4px;
		}
		.row-two {
			top: 132px;
			left: 4px;
		}
		.col-one {
			left: 68px;
			top: 4px;
		}
		.col-two {
			left: 132px;
			top: 4px;
		}
		.flip-btn {
			top: 50%;
			left: 52%;
			transform: translate(-50%, -50%);
		}
		.direction01 {
			top: 6px;
			left: 52%;
			transform: translateX(-50%);
		}
		.direction02 {
			top: 28px;
			right: 12px;
			transform: rotate(45deg);
		}
		.direction03 {
			top: 86px;
			right: -8px;
			transform: rotate(90deg);
		}
		.direction04 {
			top: 146px;
			right: 14px;
			transform: rotate(135deg);
		}
		.direction05 {
			top: 166px;
			right: 72px;
			transform: rotate(180deg);
		}
		.direction06 {
			top: 146px;
			left: 16px;
			transform: rotate(225deg);
		}
		.direction07 {
			top: 86px;
			left: -8px;
			transform: rotate(-90deg);
		}
		.direction08 {
			top: 26px;
			left: 16px;
			transform: rotate(-45deg);
		}
		.control-btn {
			width: 200px;
			height: 45px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 20px;
			border: 1px solid rgba(0, 204, 255, 1);
			box-sizing: border-box;
			margin-bottom: 10px;
			border-radius: 6px;
			font-size: 14px;
			i {
				cursor: pointer;
				font-size: 26px;
			}
		}
	}
</style>
